// import React, { useRef } from "react";

// const sizeClasses = {
//   xs: "text-[12px] h-24",
//   sm: "text-[12px] h-32",
//   md: "text-[14px] h-40",
//   lg: "text-[16px] h-48",
//   xl: "text-[18px] h-56",
// };

// const FileUploadNew = ({
//   value = [],
//   onChange,
//   multiple = false,
//   size = "md",
//   rounded = "rounded-lg",
//   accept = ".jpg, .jpeg, .png",
//   title = "",
//   width = "w-full",
//   color = "gray",
// }) => {
//   const inputRef = useRef(null);

//   const hasFileRestriction = accept.toLowerCase().trim() !== "all";

//   const handleBrowseClick = (e) => {
//     e.stopPropagation();
//     inputRef.current.click();
//   };

//   const handleFileChange = (event) => {
//     const files = Array.from(event.target.files);
//     if (files.length === 0) return;

//     if (multiple) {
//       const newFiles = files.filter(
//         (newFile) =>
//           !value.some((existingFile) => {
//             const existingFileName =
//               existingFile instanceof File
//                 ? existingFile.name
//                 : existingFile.split("/").pop();
//             const existingFileSize =
//               existingFile instanceof File ? existingFile.size : null;

//             return existingFile instanceof File
//               ? existingFile.name === newFile.name &&
//                   existingFile.size === newFile.size
//               : existingFileName === newFile.name;
//           })
//       );
//       onChange?.([...value, ...newFiles]);
//     } else {
//       onChange?.([files[0]]);
//     }
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     const files = Array.from(event.dataTransfer.files);
//     if (files.length === 0) return;

//     if (multiple) {
//       const newFiles = files.filter(
//         (newFile) =>
//           !value.some((existingFile) => {
//             const existingFileName =
//               existingFile instanceof File
//                 ? existingFile.name
//                 : existingFile.split("/").pop();
//             const existingFileSize =
//               existingFile instanceof File ? existingFile.size : null;

//             return existingFile instanceof File
//               ? existingFile.name === newFile.name &&
//                   existingFile.size === newFile.size
//               : existingFileName === newFile.name;
//           })
//       );
//       onChange?.([...value, ...newFiles]);
//     } else {
//       onChange?.([files[0]]);
//     }
//   };

//   const handleDragOver = (event) => {
//     event.preventDefault();
//   };

//   const handleEdit = (e) => {
//     e.stopPropagation();
//     inputRef.current.click();
//   };

//   const getPreviewUrl = (item) => {
//     if (typeof item === "string") {
//       return item;
//     }

//     if (item instanceof File) {
//       return URL.createObjectURL(item);
//     }
//     return "";
//   };

//   const isImageFile = (item) => {
//     if (typeof item === "string") {
//       return item.match(/\.(jpg|jpeg|png|gif|webp)$/i);
//     }
//     if (item instanceof File) {
//       return item.type.startsWith("image/");
//     }
//     return false;
//   };

//   const renderFilePreview = (item, idx) => {
//     if (isImageFile(item)) {
//       return (
//         <img
//           src={getPreviewUrl(item)}
//           alt={`Preview ${idx}`}
//           className="object-cover w-full h-24 border rounded"
//         />
//       );
//     }

//     const fileName = item instanceof File ? item.name : item.split("/").pop();
//     return (
//       <div className="flex flex-col items-center justify-center w-full h-24 border rounded bg-gray-100 p-2">
//         <span className="material-symbols-outlined text-gray-500 !text-3xl">
//           description
//         </span>
//         <p className="text-xs text-gray-600 truncate w-full text-center mt-1">
//           {fileName}
//         </p>
//       </div>
//     );
//   };

//   const renderSingleFilePreview = (item) => {
//     if (isImageFile(item)) {
//       return (
//         <img
//           src={getPreviewUrl(item)}
//           alt="Preview"
//           className="object-contain w-full h-full"
//         />
//       );
//     }

//     const fileName = item instanceof File ? item.name : item.split("/").pop();
//     return (
//       <div className="flex flex-col items-center justify-center w-full h-full">
//         <span className="material-symbols-outlined text-gray-500 !text-5xl">
//           description
//         </span>
//         <p className="text-sm text-gray-600 mt-2 px-4 text-center break-words">
//           {fileName}
//         </p>
//       </div>
//     );
//   };

//   return (
//     <div className={`flex flex-col justify-center ${width} relative mt-3`}>
//       <div className="w-full flex justify-between items-center mb-2 px-1">
//         <h6 className="text-gray-700 font-semibold text-lg">{title}</h6>
//         {value.length > 0 && (
//           <button
//             className="p-1 bg-transparent cursor-pointer"
//             onClick={handleEdit}
//           >
//             <span className="material-symbols-outlined !text-[18px]">
//               edit_square
//             </span>
//           </button>
//         )}
//       </div>

//       <div
//         className={`border-2 border-dashed border-${color}-300 ${rounded} w-full ${sizeClasses[size]} bg-${color}-50 flex flex-col items-center justify-center gap-2 cursor-pointer relative overflow-hidden`}
//         onClick={handleBrowseClick}
//         onDrop={handleDrop}
//         onDragOver={handleDragOver}
//       >
//         {value.length === 0 && (
//           <>
//             {hasFileRestriction ? (
//               <>
//                 <span className="material-symbols-outlined text-gray-500 !text-5xl">
//                   add_photo_alternate
//                 </span>
//                 <p className="text-gray-600 text-sm">
//                   Drop your image here, or{" "}
//                   <span
//                     className="text-orange-500 cursor-pointer"
//                     onClick={handleBrowseClick}
//                   >
//                     browse
//                   </span>
//                 </p>
//                 <p className="text-gray-400 text-xs">
//                   Supported file types: {accept}
//                 </p>
//               </>
//             ) : (
//               <p className="text-gray-600 text-base font-medium">
//                 Select files
//               </p>
//             )}
//           </>
//         )}

//         {value.length > 0 && multiple ? (
//           <div className="grid grid-cols-3 gap-2 p-2 w-full h-full overflow-auto">
//             {value.map((item, idx) => (
//               <div key={idx} className="relative group">
//                 {renderFilePreview(item, idx)}
//               </div>
//             ))}
//           </div>
//         ) : (
//           value.length > 0 &&
//           value[0] && (
//             <div className="relative w-full h-full group">
//               {renderSingleFilePreview(value[0])}
//             </div>
//           )
//         )}

//         <input
//           type="file"
//           accept={accept === "all" ? "" : accept}
//           multiple={multiple}
//           className="hidden"
//           ref={inputRef}
//           onChange={handleFileChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default FileUploadNew;
import React, { useRef, useState, useEffect } from "react";
import Button from "../Buttons/Button";

const sizeClasses = {
  xs: "text-[12px] h-24",
  sm: "text-[12px] h-32",
  md: "text-[14px] h-40",
  lg: "text-[16px] h-48",
  xl: "text-[18px] h-56",
};

const formatFileName = (name, start = 20, end = 10) => {
  if (!name) return "";

  if (name.length <= start + end + 3) {
    return name; // small name → return as-is
  }

  const extensionIndex = name.lastIndexOf(".");
  const extension = extensionIndex !== -1 ? name.slice(extensionIndex) : "";

  const baseName = extensionIndex !== -1 ? name.slice(0, extensionIndex) : name;

  return baseName.slice(0, start) + "..." + baseName.slice(-end) + extension;
};

const FileUploadNew = ({
  size = "md",
  className = "",
  onChange,
  accept = ".jpg, .jpeg, .png",
  multiple = false,
  disabled = false,
  value,
  title = "",
  width = "w-full",
  color = "gray",
  rounded = "rounded-lg",
  maxFiles = 15,
  shadow = false,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const hasFileRestriction = accept.toLowerCase().trim() !== "all";

  useEffect(() => {
    // Sync external value with internal selectedFiles to show existing previews
    if (value && Array.isArray(value)) {
      setSelectedFiles(value);
    } else if (value && typeof value === "string") {
      setSelectedFiles([value]);
    } else if (!value || value.length === 0) {
      setSelectedFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [value]);

  const areFilesEqual = (file1, file2) => {
    return (
      file1.name === file2.name &&
      file1.size === file2.size &&
      file1.type === file2.type &&
      file1.lastModified === file2.lastModified
    );
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files?.length > 0) {
      const newFiles = Array.from(files);
      let updatedFiles;

      if (multiple) {
        const uniqueNewFiles = newFiles.filter(
          (newFile) =>
            !selectedFiles.some((existingFile) =>
              areFilesEqual(existingFile, newFile),
            ),
        );

        // Check file limit
        if (
          maxFiles &&
          selectedFiles.length + uniqueNewFiles.length > maxFiles
        ) {
          const remainingSlots = maxFiles - selectedFiles.length;
          if (remainingSlots > 0) {
            updatedFiles = [
              ...selectedFiles,
              ...uniqueNewFiles.slice(0, remainingSlots),
            ];
            alert(
              `File limit reached. You can only upload ${maxFiles} files. Added ${remainingSlots} file(s).`,
            );
          } else {
            alert(`File limit reached. Maximum ${maxFiles} files allowed.`);
            return;
          }
        } else {
          updatedFiles = [...selectedFiles, ...uniqueNewFiles];
        }
      } else {
        updatedFiles = newFiles;
      }

      setSelectedFiles(updatedFiles);
      triggerChange(updatedFiles);
    }
    e.target.value = "";
  };

  const triggerChange = (files) => {
    onChange && onChange(files);
  };

  const handleDeleteFile = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    triggerChange(newFiles);
  };

  const handleBrowseClick = (e) => {
    e.stopPropagation();
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (disabled) return;

    const files = Array.from(event.dataTransfer.files);
    if (files.length === 0) return;

    let updatedFiles;

    if (multiple) {
      const uniqueNewFiles = files.filter(
        (newFile) =>
          !selectedFiles.some((existingFile) =>
            areFilesEqual(existingFile, newFile),
          ),
      );

      // Check file limit
      if (maxFiles && selectedFiles.length + uniqueNewFiles.length > maxFiles) {
        const remainingSlots = maxFiles - selectedFiles.length;
        if (remainingSlots > 0) {
          updatedFiles = [
            ...selectedFiles,
            ...uniqueNewFiles.slice(0, remainingSlots),
          ];
          alert(
            `File limit reached. You can only upload ${maxFiles} files. Added ${remainingSlots} file(s).`,
          );
        } else {
          alert(`File limit reached. Maximum ${maxFiles} files allowed.`);
          return;
        }
      } else {
        updatedFiles = [...selectedFiles, ...uniqueNewFiles];
      }
    } else {
      updatedFiles = [files[0]];
    }

    setSelectedFiles(updatedFiles);
    triggerChange(updatedFiles);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const getPreviewUrl = (item) => {
    if (item instanceof File) {
      return URL.createObjectURL(item);
    }
    if (typeof item === "string") {
      return item;
    }
    return "";
  };

  const isImageFile = (item) => {
    if (item instanceof File) {
      return item.type.startsWith("image/");
    }
    if (typeof item === "string") {
      // Handle URLs with query parameters by checking extension before '?' or at end
      return item.split('?')[0].match(/\.(jpg|jpeg|png|gif|webp)$/i);
    }
    return false;
  };

  const renderFilePreview = (item, idx) => {
    if (isImageFile(item)) {
      return (
        <img
          src={getPreviewUrl(item)}
          alt={`Preview ${idx}`}
          className="object-cover w-full h-24 border rounded"
        />
      );
    }

    const fileName = item instanceof File ? item.name : (typeof item === "string" ? item.split("/").pop().split('?')[0] : "");
    return (
      <div className="flex flex-col items-center justify-center w-full h-24 border rounded bg-gray-100 p-2">
        <span className="material-symbols-outlined text-gray-500 !text-3xl">
          description
        </span>
        <p className="text-xs text-gray-600 truncate w-full text-center mt-1">
          {formatFileName(fileName)}
        </p>
      </div>
    );
  };

  const renderSingleFilePreview = (item) => {
    if (isImageFile(item)) {
      return (
        <img
          src={getPreviewUrl(item)}
          alt="Preview"
          className="object-contain w-full h-full"
        />
      );
    }

    const fileName = item instanceof File ? item.name : (typeof item === "string" ? item.split("/").pop().split('?')[0] : "");
    return (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <span className="material-symbols-outlined text-gray-500 !text-5xl">
          description
        </span>
        <p className="text-sm text-gray-600 mt-2 px-4 text-center break-words">
          {formatFileName(fileName)}
        </p>
      </div>
    );
  };

  return (
    <div
      className={`flex flex-col justify-center ${width} relative ${className}`}
    >
      <div className="w-full flex justify-between items-center mb-2 px-1">
        <h6 className="text-gray-700 font-semibold text-lg">{title}</h6>
        {multiple && selectedFiles.length > 0 && (
          <h6 className="text-gray-700 font-semibold text-sm">
            ({selectedFiles.length}
            {maxFiles ? `/${maxFiles}` : ""})
          </h6>
        )}
      </div>

      <div
        className={`border-2 border-dashed border-${color}-300 ${rounded} w-full ${
          sizeClasses[size]
        } bg-${color}-50 flex flex-col items-center justify-center gap-2 relative overflow-hidden ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}`}
        onClick={handleBrowseClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {selectedFiles.length === 0 && (
          <>
            {hasFileRestriction ? (
              <>
                <span className="material-symbols-outlined text-gray-500 !text-5xl">
                  add_photo_alternate
                </span>
                <p className="text-gray-600 text-sm">
                  Drop your file{multiple ? "s" : ""} here, or{" "}
                  <span
                    className="text-orange-500 cursor-pointer"
                    onClick={handleBrowseClick}
                  >
                    browse
                  </span>
                </p>
                <p className="text-gray-400 text-xs">
                  Supported file types: {accept}
                </p>
                {maxFiles && multiple && (
                  <p className="text-gray-400 text-xs">
                    Maximum files: {maxFiles}
                  </p>
                )}
              </>
            ) : (
              <>
                <p className="text-gray-600 text-base font-medium">
                  Select files
                </p>
                {maxFiles && multiple && (
                  <p className="text-gray-400 text-xs">
                    Maximum files: {maxFiles}
                  </p>
                )}
              </>
            )}
          </>
        )}

        {selectedFiles.length > 0 && multiple ? (
          <>
            <p className="text-gray-600 text-base font-medium">Select files</p>
            {maxFiles && multiple && (
              <p className="text-gray-400 text-xs">Maximum files: {maxFiles}</p>
            )}
          </>
        ) : (
          selectedFiles.length > 0 && (
            <>
              <p className="text-gray-600 text-base font-medium">Select file</p>
            </>
          )
        )}

        <input
          type="file"
          accept={accept === "all" ? "" : accept}
          multiple={multiple}
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
          disabled={disabled}
        />
      </div>

      {/* Uploaded Files List */}
      {selectedFiles.length > 0 && (
        <div className="mt-4 max-h-[150px] overflow-auto">
          <div className="rounded-lg flex gap-5 flex-wrap">
            {selectedFiles.map((file, index) => (
              <div
                key={index}
                className="flex items-center gap-2 p-1 hover:bg-gray-50 transition-colors  bg-primary-50 rounded-full px-4"
              >
                <p
                  className="font-medium text-sm truncate cursor-pointer flex-1"
                  title={file instanceof File ? file.name : (typeof file === "string" ? file.split("/").pop().split('?')[0] : "")}
                >
                  {formatFileName(file instanceof File ? file.name : (typeof file === "string" ? file.split("/").pop().split('?')[0] : ""))}
                </p>
                <Button
                  type="icon"
                  icon="delete"
                  size="xs"
                  color="danger"
                  variant="text"
                  onClick={() => handleDeleteFile(index)}
                  disabled={disabled}
                />
              </div>

              // <div
              //   key={index}
              //   className="flex items-center justify-between p-1 hover:bg-gray-50 transition-colors"
              // >
              //   <div className="flex items-center gap-3 flex-1 min-w-0">
              //     <div className="flex-1 min-w-0">
              //       <p
              //         className="font-medium text-sm truncate cursor-pointer"
              //         title={file.name} // full name on hover
              //       >
              //         {formatFileName(file.name)}
              //       </p>
              //     </div>
              //   </div>
              //   <Button
              //     type="icon"
              //     icon="delete"
              //     size="xs"
              //     color="danger"
              //     variant="text"
              //     onClick={() => handleDeleteFile(index)}
              //     disabled={disabled}
              //   />
              // </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadNew;
